import { Modal, Paper } from "@mui/material";
import React from "react";
import styled from "styled-components";
import Stack from "@mui/material/Stack";
import SingleDatePickerNew from "src/components/single-date-picker-new";

const ModalContainer = styled(Paper)`
    position: absolute;
`;

const SingleDatePickerModal = ({
    handleClose,
    open,
    setDatepickerModalOpen,
    setMissionEndDate,
}) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        >
            <ModalContainer>
                <Stack direction="column">
                    <SingleDatePickerNew
                        handleChange={setMissionEndDate}
                        toggleDatepicker={() => setDatepickerModalOpen(false)}
                    />
                </Stack>
            </ModalContainer>
        </Modal>
    );
};
export default SingleDatePickerModal;
